import axios from "axios";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = "/webhooks";

export const fetchWebhookConfigurationBySetting = async (settingId) => {
  const res = await axios.get(
    `${process.env.REACT_APP_SERVER}${BASE_URL}/configuration/${settingId}`,
    getAuthHeaders(),
  );

  return res.data;
};

export const saveWebhookConfiguration = async (payload) => {
  const res = await axios.post(
    `${process.env.REACT_APP_SERVER}${BASE_URL}/configuration`,
    payload,
    getAuthHeaders(),
  );

  return res.data;
};
